import React, { useEffect } from "react"

export default () => {

  useEffect(() => {
    document.getElementById('parrent').addEventListener('scroll', e => {
      // console.log(document.getElementById('parrent').scrollTop, document.getElementById('parrent').scrollHeight - document.documentElement.clientHeight + 87, document.documentElement.clientWidth)
      console.log()
      document.getElementById('scroll-nav').style.width = `${document.getElementById('parrent').scrollTop * 100 / (document.getElementById('parrent').scrollHeight - (document.documentElement.clientHeight + 87))}%`
      // console.log(document.getElementById('scroll-nav').style.width, document.getElementById('parrent').scrollTop * 100 / document.getElementById('parrent').scrollHeight - document.documentElement.clientHeight + 87)
    })
  })

  return (
    <div className="progress" style={{ height: 2 }}>
      <span id="scroll-nav" className="blocked bg-tomato" style={{ height: 2, width: 0 }} />
    </div>
  )
}
